import actions from './actions'
import mutations from './mutations'

const INITIAL_LIBRARY_FILTER = {
  value: 'by_latest',
  text: 'RECENTLY_OPENED'
}
const INITIAL_LIBRARY_FILTER_OFFLINE = 'all'

const state = {
  locale: 'nb',
  dictLang: 'en_GB',
  dictName: 'engelsk',
  zoomLevel: 100,
  pagesPerView: 2,
  lastReadPage: {},
  connection: true,
  bubbleAccepted: false,
  libraryFilter: INITIAL_LIBRARY_FILTER,
  libraryLoaded: 0,
  libraryScrollPos: 0,
  libraryFilterOffline: INITIAL_LIBRARY_FILTER_OFFLINE,
  responsive: 'desktop'
}

export default {
  state,
  actions,
  mutations,
  namespaced: true
}
